/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class VehicleEquipmentListModel extends JSONable{
  uuid: string | undefined
  equipmentType: string | undefined
  installationDate: string | undefined
  uninstallationDate: string | undefined
  validFrom: string | undefined
  validTo: string | undefined
}
